import { Inject, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ObjectCache } from 'Src/ng2/shared/services/object-cache/object-cache.service';
export interface INgRouterQueryParams {
  relativeTo: ActivatedRoute;
  queryParams: {
    focus: string;
    filter: string;
    grouping: string;
  };
  replaceUrl: boolean;
  queryParamsHandling: string;
}
@Injectable()
export class NgRouterNavigationService {
  constructor(public router: Router, @Inject('$window') public $window: any, private objectCache: ObjectCache) {}

  updateUrl(route: string[], extras = {}): void {
    this.router.navigate(route, extras);
  }

  goToProfile(payload: {
    caresIds: string[];
    updateRelPath: string;
    queryParamsHandling: string;
    route: ActivatedRoute;
  }): void {
    const { caresIds, updateRelPath, queryParamsHandling, route } = payload;
    const hashedCaresIds = this.objectCache.cacheObject(caresIds);
    const extras = {
      relativeTo: route,
      queryParams: {
        sort: null,
        filter: null,
        students: hashedCaresIds,
      },
      queryParamsHandling,
    };
    this.updateUrl([updateRelPath], extras);
  }
}
